import { useState, useEffect } from "react";
import "./SuggestedProfileCard.css";
import { FaHeart, FaEye, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { get } from "../../http/api";
import { requestMatch } from '../../premium/requestMatch';
import { useTranslation } from "react-i18next";
import { getProfileDisplayName } from "../../utils/profileDisplayName";


export default function SuggestedProfileCard({ profile }) {

  const navigate = useNavigate();
  const [matchStatus, setMatchStatus] = useState("none");


  useEffect(() => {
    fetchStatus();
  }, []);


  const fetchStatus = async () => {
    try {
      const res = await get(`matches/status/${profile.id}`);
      if (
        res?.data?.status
      ) {
        setMatchStatus(
          res.data.status
        );
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  const { t } = useTranslation();
  const displayName = getProfileDisplayName(profile);

  const normalizedRole = String(profile?.role || "").trim().toLowerCase();
  const roleLabel = normalizedRole
    ? t(`matchCard.${normalizedRole}`, { defaultValue: profile.role })
    : "";

  const handleMatch = async () => {
    try {
      const res = await requestMatch(profile.id);
      if (!res) return;
      if (
        res?.data?.status
      ) {
        setMatchStatus(
          res.data.status
        );
      }
      else {
        setMatchStatus(
          "sent"
        );
      }
    }
    catch (err) {
      console.log(err);
    }
  };

  const navToProfile = () => {
    navigate(`/user/${profile.username}`);
  }

  return (
    <div className="suggested-card">
      <div className="suggested-header">
        <span className="badge"> {t("suggestedProfile.recommendedProfile")} </span>
      </div>

      <div className="suggested-body">
        <div className="avatar">
          {profile.avatar ? (
            <img src={profile.avatar} alt="" />
          ) : (
            <div className="avatar-placeholder">
              {displayName?.[0] || "?"}
            </div>
          )}
        </div>

        <div className="info">
          <h4>{displayName}</h4>
          <p>
            {roleLabel} • {profile.sport}
          </p>
          {profile.position && <p>{profile.position}</p>}
        </div>
      </div>

      <div className="suggested-actions">
        <button className={`like ${matchStatus === "sent" ? "sent-btn" : ""}`}
          onClick={handleMatch}
          disabled={matchStatus === "sent"}
        >
          {

            matchStatus === "sent"

              ? <> <FaCheck /> {t("suggestedProfile.requestSent")} </>
              : <> <FaHeart /> {t("suggestedProfile.interested")} </>
          }
        </button>
        <button className="view" onClick={navToProfile}>
          <FaEye /> {t("suggestedProfile.viewProfile")}
        </button>
      </div>
    </div>
  );
}
